<template>
    <div class="card h-auto col-md-6 col-md-6 col-sm-12 mt-md-0 mb-lg-0 mb-md-0 mb-4 position-relative">
        <div v-if="loading" class="d-flex justify-content-center align-items-center col-12"
            style="height: 100px;top: 0;left: 0;">
            <p class="text-center"><i class="fas fa-spinner fa-pulse"></i> Aguarde</p>
        </div>

        <div v-else>
            <div v-if="!openParcels || openParcels.length === 0" class="row">
                <div class="col-12 segment-primary-color d-flex justify-content-center font-weight-bolder mt-6">
                    Nenhuma Parcela Encontrada Para Este Mês
                </div>
            </div>

            <div v-else>
                <div class="row mt-3 mx-4">
                    <div class="col-6 col-sm-6 col-md-6">
                        <div class="row d-flex font-weight-bolder justify-content-start line">Próxima Parcela</div>
                        <div class="row d-flex justify-content-start line bg-custom">Origem</div>
                        <div class="row d-flex justify-content-start line">Tipo</div>
                    </div>
                    <div class="col-6 col-sm-6 col-md-6">
                        <div class="row d-flex font-weight-bolder justify-content-end line">
                            {{ formatDate(currentParcel.par_dt_vencimento) }}
                        </div>
                        <div class="row d-flex justify-content-end bg-custom line">{{ currentParcel.par_origem_parcela
                            }}
                        </div>
                        <div class="row d-flex justify-content-end line">{{ currentParcel.par_ch_parcela }}</div>
                    </div>
                </div>
                <div class="row mx-3">
                    <div class="row d-flex justify-content-center font-weight-bolder segment-primary-color"
                        style="font-size: 1.3rem;padding: 8px 0;">
                        {{ currencyFormat(currentParcel.par_re_valororiginal) }}
                    </div>
                    <div id="parcel-value"
                        class="row d-flex justify-content-center font-weight-bolder segment-primary-color"
                        style="font-size: 20px; display: none !important;">
                        {{ currentParcel.barcode }}
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="font-weight-bolder mt-1 d-flex flex-wrap justify-content-center">
                        <div class="col-6 col-sm-6 col-md-4 mb-2 d-flex justify-content-center">
                            <button @click="copyCode"
                                class="btn custom-btn custom-btn-sm bg-segment-primary-color w-100"
                                style="white-space: nowrap;">Copiar código
                            </button>
                        </div>
                        <div class="col-6 col-sm-6 col-md-4 mb-2 d-flex justify-content-center">
                            <button type="button" @click="showPaymentSlip(currentParcel.par_in_codigo)"
                                class="btn custom-btn custom-btn-sm bg-segment-primary-color w-100" :disabled="loadingVisiblePaymetSlip"
                                style="white-space: nowrap;">Ver boleto <i v-if="loadingVisiblePaymetSlip" class="fa fa-spinner fa-pulse fa-fw"></i>
                            </button>
                        </div>
                        <div class="col-6 col-sm-6 col-md-4 mb-2 d-flex justify-content-center">
                            <button type="button" @click="visible = true"
                                class="btn custom-btn custom-btn-sm bg-segment-primary-color w-100"
                                style="white-space: nowrap;">Receber por e-mail
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div v-if="openParcels.length > 1">
            <div class="btn-container left">
                <a @click="previousParcel" :disabled="currentIndex === 0" class="btn-icon">
                    <i class="fas fa-chevron-left"></i>
                </a>
            </div>
            <div class="btn-container right">
                <a @click="nextParcel" :disabled="currentIndex === openParcels.length - 1" class="btn-icon">
                    <i class="fas fa-chevron-right"></i>
                </a>
            </div>
        </div>
    </div>

    <Dialog v-model:visible="visible" modal header="Receber por e-mail" :style="{ width: '25rem' }">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-2 mt-sm-0">
            <label>Enviar boleto para</label>
            <argon-input id="mail" v-model="email" class="multisteps-form__input" type="text"
                placeholder="mail@mail.com.br" />
        </div>
        <div class="mt-4 d-flex justify-content-center">
            <button type="button" @click="sendMail()" :disabled="loadingRequestMail"
                class="btn custom-btn bg-segment-primary-color text-center d-flex justify-content-center">Confirmar <i
                    v-if="loadingRequestMail" class="fa fa-spinner fa-pulse fa-fw"></i>
            </button>
        </div>
    </Dialog>

    <Dialog v-model:visible="visiblePaymetSlip" modal header="" :style="{ width: '25rem' }">
        <div ref="pdfContainer" style="width: 100%; height: 600px;"></div>
    </Dialog>
</template>

<script setup>
import axios from 'axios';
import { onMounted, ref, computed } from 'vue';
import moment from 'moment';
import { useStore } from "vuex";
import { showToast } from "@/assets/js/toast.js";
import Dialog from 'primevue/dialog';
import ArgonInput from "@/components/ArgonInput.vue";

const store = useStore();

const contractData = computed(() => store.getters.getCurrentContract);
const openParcels = ref([]);
const currentIndex = ref(0);
const loading = ref(true);
const loadingRequestMail = ref(false);
const visible = ref(false);
const visiblePaymetSlip = ref(false);
const loadingVisiblePaymetSlip = ref(false);
const email = ref('');

const currentParcel = computed(() => openParcels.value[currentIndex.value]);
const userAgent = store.getters.getCurrentUser ? store.getters.getCurrentUser.id : null;

onMounted(async () => {
    moment.locale('pt-br');
    openParcels.value = await fetchOpenParcels();
    loading.value = false;
});

async function fetchOpenParcels() {
    try {
        const response = await axios.get(`/clients/contract/${contractData.value.contrato_id}/plots?status=EM_ABERTO`);
        console.log(response);

        return response.data.length ? response.data : [];
    } catch (error) {
        console.log(error);
        return [];
    }
}

const formatDate = (date) => {
    return moment(date).format('DD/MM/YYYY');
};

const currencyFormat = (value, currency = false) => {
    const options = {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    };

    const formattedValue = new Intl.NumberFormat('pt-BR', options).format(value);

    if (currency) {
        return `${formattedValue}`;
    }

    return formattedValue;
};

// Função para copiar código
const copyCode = () => {
    const parcelValueElement = document.getElementById('parcel-value');
    const parcelValue = parcelValueElement.innerText;

    navigator.clipboard.writeText(parcelValue).then(() => {
        showToast('Código copiado para a área de transferência', 'success');
    }).catch(err => {
        console.error('Erro ao copiar código: ', err);
    });
};

async function sendMail() {
    try {
        loadingRequestMail.value = true

        let data = {
            parcel: [currentParcel.value.par_in_codigo],
            email: email.value,
            notificacao: false
        };

        const response = await axios.post(`/contract-ws/${contractData.value.contrato_id}/duplicate`, data);

        if (response.status == 200) {
            showToast('Boleto enviado com sucesso.', 'success');
        }
    } catch (error) {
        console.log(error);
        //
    } finally {
        visible.value = false
        loadingRequestMail.value = false
    }
}

async function showPaymentSlip(code) {
    try {
        loadingVisiblePaymetSlip.value = true

        let data = {
            contract: contractData.value.contrato_id,
            agent: userAgent,
            code: code
        };

        const response = await axios.post(`/boleto-ws`, data);

        if (response.status == 200) {
            if(response.data.ERRO){
                showToast('Boleto não encontrado.', 'error');
                return;
            }
            openPDF(response.data.BOLETO)
        }
    } catch (error) {
        showToast('Erro ao buscar boleto.', 'error');
    } finally {
        loadingVisiblePaymetSlip.value = false
    }
}

const openPDF = (base64PDF) => {
    const byteCharacters = atob(base64PDF);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const blobURL = URL.createObjectURL(blob);

    window.open(blobURL, '_blank');
}

const nextParcel = () => {
    if (currentIndex.value < openParcels.value.length - 1) {
        currentIndex.value++;
    }
};

const previousParcel = () => {
    if (currentIndex.value > 0) {
        currentIndex.value--;
    }
};
</script>

<style scoped>
.btn {
    margin-bottom: 1rem !important;
    letter-spacing: -.025rem !important;
    font-size: .75rem !important;
    padding: 7px 20px !important;
    text-transform: none !important;
    box-shadow: 0 4px 6px rgba(50, 50, 93, .1), 0 1px 3px rgba(0, 0, 0, .08) !important;
}

.custom-btn-sm {
    width: 170px;
    margin: 0px 10px 12px 10px !important;
}

.btn-icon {
    background: none;
    border: none;
    padding: 0;
    font-size: 1.5rem;
    cursor: pointer;
}

.position-relative {
    position: relative;
}

.btn-container {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.btn-container.left {
    left: 10px;
}

.btn-container.right {
    right: 10px;
}

.bg-custom {
    background-color: #FAFAFA;
}

.line {
    padding-left: 5px;
    padding-right: 5px;
    white-space: nowrap;
}
</style>
